// src/utils/manualConvertTrade.js
// Pure logic extracted from ManualConvertTradeEntry.js so it can be unit
// tested without pulling in the component's MUI/Axios import chain (see
// ManualConvertTradeEntry.test.js).

// Severity for the post-submit result Alert. A binary FAILED/success check
// would render ENTERED_WITH_WARNINGS as green even though its Chip is amber
// and the same status renders as an amber warning Alert on Converts_Blotter.js.
export function getResultSeverity(status) {
  if (status === "FAILED") return "error";
  if (status === "ENTERED_WITH_WARNINGS") return "warning";
  return "success";
}

// A completed non-FAILED submission already booked a real trade at Eze under
// a fresh server-generated trade_id — the form must not be resubmittable
// until the trader explicitly starts over via "Enter Another Trade" (which
// clears submitResult back to null). A FAILED result booked nothing, so it
// stays submittable without that extra step.
export function canSubmitTrade(submitResult) {
  return !submitResult || submitResult.status === "FAILED";
}

// Builds the POST payload from form state. `form.security` may be a plain
// string (typed freely) or a security object (selected from the Autocomplete
// dropdown) — either way the payload always carries the plain symbol string.
export function buildManualTradePayload(form) {
  const securitySymbol =
    typeof form.security === "string"
      ? form.security.trim()
      : form.security?.SYMBOL || "";
  return {
    security_symbol: securitySymbol,
    strategy_name: form.strategy.trim(),
    action: form.action,
    quantity: Number(form.quantity),
    price: Number(form.price),
    broker: form.broker.trim(),
    trader: form.trader.trim(),
    manager: form.manager.trim(),
    currency: form.currency.trim(),
    trade_date: form.trade_date,
  };
}
